import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar, Nav, Container, Image } from 'react-bootstrap';
import { GlobalContext, GlobalContextType } from '../context/GlobalContext';
// import { useIsLoggedIn } from './Helpers';


function Header() {
  const navigate = useNavigate();
  const global = useContext<GlobalContextType>(GlobalContext)

  return (
    <Navbar expand="md" className="modern-header">
      <Container>
        <Navbar.Brand as={Link} to="/" className="brand-logo">
          <Image src="/logo64.png" alt="Press Forward Mail Logo" className="logo-img" />
          <span className="brand-text">Press Forward Mail</span>
        </Navbar.Brand>
        
        <Navbar.Toggle aria-controls="header-nav" className="navbar-toggler" />
        
        <Navbar.Collapse id="header-nav" className="justify-content-end">
          {global.session ? (
            <Nav className="nav-links">
              <Nav.Link as={Link} to="/dashboard" className="nav-item">
                Dashboard
              </Nav.Link>
              <Nav.Link onClick={() => navigate('/logout')} className="nav-item logout-btn">
                Logout
              </Nav.Link>
            </Nav>
          ) : (
            <Nav className="nav-links">
              <Nav.Link as={Link} to="/" className="nav-item">
                Home
              </Nav.Link>
              <Nav.Link as={Link} to="/about" className="nav-item">
                About
              </Nav.Link>
              <Nav.Link as={Link} to="/pricing" className="nav-item">
                Pricing
              </Nav.Link>
              <Nav.Link as={Link} to="/login" className="nav-item signin-btn">
                Sign In
              </Nav.Link>
            </Nav>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
